<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">

      </div>
    </template>

    <template #layoutContent>
      <div class="card shadow-sm">
        <div class="card-header card-header-stretch min-h-50px">

          <div v-if="loadingPage" class="loader-overlay">
            <div class="loader"></div>
          </div>

          <div class="card-toolbar d-flex justify-content-between w-100">
            <ul class="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
              <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" href="#kt_tab_pane_7">
                  <span class="fw-bold fs-3">{{ $t('qvct_survey.information') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_8">
                  <span class="fw-bold fs-3">{{ $t('qvct_survey.questions') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_9">
                  <span class="fw-bold fs-3">{{ $t('qvct_survey.responses') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_10">
                  <span class="fw-bold fs-3">{{ $t('qvct_survey.statistics') }}</span>
                </a>
              </li>

              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_11">
                  <span class="fw-bold fs-3">{{ $t('qvct_survey.report') }}</span>
                </a>
              </li>

            </ul>

            <div class="ms-auto mt-3 d-flex gap-3 align-items-center">

              <div class="dropdown position-relative" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
                <button class="btn btn-sm dropdown-toggle text-white" :class="`btn-${currentStatusColor}`" type="button">
                  {{currentStatusLabel }}
                </button>
                <ul
                    class="dropdown-menu mt-1"
                    v-show="showDropdown"
                    style="display: block; position: absolute; z-index: 1000;"
                >

                  <li v-for="status in surveyStatusFiltered" :key="status.value">
                    <a class="dropdown-item" href="#" @click.prevent="setSurveyStatus(status.value)">
                      {{ status[locale] }}
                    </a>
                  </li>
                </ul>
              </div>

              <a :href="previewUrl" target="_blank" class="btn btn-sm btn-primary me-2">
                <i class="fas fa-eye"></i>
                {{ $t('qvct_survey.preview_form') }}
              </a>

              <button @click.prevent="copyText" class="btn btn-sm btn-primary me-2">
                <i class="fas fa-copy"></i>
                {{ $t('qvct_survey.copy_link') }}
              </button>

              <button class="btn btn-primary btn-sm" @click="openSendModal">
                <i class="bi bi-send me-1"></i> {{ $t('button.send') }}
              </button>
            </div>
          </div>
        </div>

        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="kt_tab_pane_7" role="tabpanel">
            <SurveyInformation v-if="survey" />
          </div>

          <div class="tab-pane fade" id="kt_tab_pane_8" role="tabpanel">
            <SurveyFields  v-if="survey" />
          </div>

          <div class="tab-pane fade" id="kt_tab_pane_9" role="tabpanel">
            <SurveyResponse v-if="survey" :survey="survey"/>
          </div>

          <div class="tab-pane fade" id="kt_tab_pane_10" role="tabpanel">
            <SurveyStatistics v-if="survey" :survey="survey" :surveyStats ="surveyStats"/>
          </div>
          <div class="tab-pane fade" id="kt_tab_pane_11" role="tabpanel">
            <SurveyReport type="rps" v-if="survey" :survey="survey"
                          :surveyReport="surveyReports"
                          :surveyOpinion="surveyOpinion"
                          :surveyParentCategory="surveyParentCategory"
                          :responseMarks="responseMarks"
                          @changeStats = "loadReportData" />
          </div>

        </div>

        <SendMailModal
            id="send_qvct_link"
            :surveyId="currentSurveyId"
        />
      </div>
    </template>
  </SubLayout>
</template>

<script setup>
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {formatDate, getTenantId} from "@/mixins/Helpers";
import {useRoute} from "vue-router";
import SurveyInformation from "@/Modules/Qvct/views/Survey/components/SurveyInformation.vue";
import SurveyFields from "@/Modules/Qvct/views/Survey/components/SurveyFields.vue";
import Button from "@/components/Button.vue";
import SendMailModal from "@/Modules/Qvct/views/Survey/components/SendMailModal.vue";
import SurveyResponse from "@/Modules/Qvct/views/Survey/components/SurveyResponse.vue";
import {useLocales} from "@/composables/locales";
import {getQvctSurveyStatus} from "@/Modules/Qvct/store/modules/qvctSurvey/getters";
import  {APP_URL} from '@/services/api'
import SurveyReport from "@/Modules/Qvct/views/Survey/components/SurveyReport.vue";
import {loadQvctSurveyRootCategories} from "@/Modules/Qvct/store/modules/qvctSurvey/actions";
import SurveyStatistics from "@/Modules/Qvct/views/Survey/components/SurveyStatistics.vue";


const { locale } = useLocales()
const store = useStore()
const showDropdown = ref(false)
const loadingPage = ref(false)
const title = ref('qvct_survey.survey.view')
const processing = ref(false)
const surveyReportData = ref('')
const route = useRoute()
const currentSurveyId = route.params.id
const survey = computed(() => store.getters['qvctSurvey/getQvctSurvey'](route.params.id))
const surveyStatus = computed(() => store.getters['qvctSurvey/getQvctSurveyStatus'])
const surveyParentCategory = computed(() => store.getters['qvctSurvey/getQvctServeysRootCategories'])
const surveyStatusFiltered = computed(() => surveyStatus.value.filter(x => x.value !== survey.value?.status?.value))
const surveyReports = computed(() => store.getters['qvctSurveysReport/getQvctSurveyReport'])
const responseMarks = computed(() => store.getters['qvctAnswerMark/getQvctAnswerMark'])
const surveyStats = computed(() => store.getters['qvctSurvey/getQvctSurveyStats'](route.params.id))
const surveyOpinion = computed(() => store.getters['qvctSurvey/getQvctSurveyOpinion'](route.params.id))



const currentStatusLabel = computed(() => {
  return survey.value?.status[locale.value] || ''
})

const currentStatusColor = computed(() => {
  return survey.value?.status?.color ? `bg-${survey.value.status.color}` : ''
})
const breadcrumbs = ref([
  {
    name: 'navigation.dashboard',
    route: 'home-path'
  },
  {
    name: 'navigation.qvct_survey',
    route: 'qvct-survey-index'
  },
  {
    name: 'navigation.qvct_survey_view',
    path: 'qvct-survey-create'
  }
])

const minDate = formatDate(new Date())

const previewUrl = computed(() => `${APP_URL}/preview/qvct/survey/${route.params.id}/information`)


function copyText() {
  let text = APP_URL + `/qvct/survey/${route.params.id}/information`
  const textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand("copy");
    window.toastr.success('Lien copier')
  } catch (err) {
    console.error("Erreur de copie : ", err);
  }
  document.body.removeChild(textarea);
}

function addQuestion() {
  formData.value.fields.push({
    type: 'radio',
  })
}

function removeQuestion(position) {
  formData.value.fields = formData.value.fields.filter((x, key) => {
    return key !== position
  })
}


function openSendModal(){
  $('#kt_modal_send_qvct_link').modal('toggle')
}


function setSurveyStatus(newStatusValue) {
  processing.value = true

  const payload = {
    id: route.params.id,
    status: newStatusValue
  }

  store.dispatch('qvctSurvey/updateSurveyStatus', payload)
      .then(() => {
        window.toastr['success'](i18n.global.t("notification.status_updated"))
        loadData()
      })
      .catch(() => {
        window.toastr['error'](i18n.global.t("notification.update_failed"))
      })
      .finally(() => {
        processing.value = false
      })
}



function loadData() {
  if(route.params.id) {
    loadingPage.value = true
    store.dispatch('qvctSurvey/loadQvctSurvey', route.params.id)
        .then(() => {
          loadingPage.value = false
        })
        .catch(() => {
          loadingPage.value = false
        })
    store.dispatch('qvctSurvey/loadQuestions', route.params.id)
  }

  store.dispatch('qvctSurvey/loadQvctSurveyCategoriesWithoutChildren')
  store.dispatch('qvctSurvey/loadQvctSurveyRootCategories')
  store.dispatch('qvctSurvey/loadAnswersTypes')
  store.dispatch('qvctSurvey/loadQvctSurveyStatus')
  store.dispatch('qvctAnswerMark/loadQvctAnwerMark')
  store.dispatch('qvctSurvey/loadQvctSurveyStats',route.params.id)
  store.dispatch('qvctSurvey/loadQvctSurveyOpinion',route.params.id)

}


const loadReportData = async (parentCategoryIds, allPopulations) => {
  try {
    const surveyId = String(route.params.id);
    const response = await store.dispatch('qvctSurveysReport/loadQvctSurveyReportStats', {
      id: surveyId,
      category_id: parentCategoryIds,
      group_by_population: allPopulations
    })

  } catch (error) {

  }
}

const reloadDataWithCurrentFilters = async () => {
  if (surveyParentCategory.value && surveyParentCategory.value.length > 0) {
    const firstCategory = surveyParentCategory.value[0].id

    await loadReportData(firstCategory, true)
  }
}

onMounted(() => {
  loadData()
  loadReportData(null, true)

  setTimeout(() => {
    reloadDataWithCurrentFilters()
  }, 1000)
})


</script>

<style scoped>

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.loader {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top-color: #007BFF;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.nav-tabs .nav-link.active .fs-3 {
  color: var(--bs-primary) !important;
}
</style>